import React, { useState, useEffect } from "react"
import _ from "lodash"
import portfolioService from "data/portfolio"

type IAtRest = {
  rowData: {
    portfolioid: number
  }
  namedItems?: {
    userGroups: {usergroupid: number}[]
  }
  field?: string
}

const UserAccessAtRest = (props: IAtRest) => {
  const userGroups = _.get(props, "namedItems.userGroups");
  const [selectedGroups, setSelectedGroups] = useState<Array<number>>([]);

  useEffect(() => {
    const portfolio = _.find(portfolioService.value(), {portfolioid: props.rowData.portfolioid})
    setSelectedGroups(_.chain(portfolio).get('usergroups').map('usergroupid').uniq().value())
  }, [props.rowData])

  if(selectedGroups.length === 1) {
    let code = _.get(_.find(userGroups, (g) => g.usergroupid === selectedGroups[0]), "code")
    return <span>{`User Group: ${code}`}</span>
  } else return <span>User Groups: Detailed</span>
}

export default UserAccessAtRest
